export default __webpack_public_path__ + "static/media/nevada.85051671.jpg";